function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shortcut",
  clipPath: "url(#clip0_1988_24001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M13.7336 0C16.5536 2.66075 19.2544 5.20884 22.0013 7.80147C19.2544 10.3941 16.5536 12.9422 13.7606 15.5767V10.9011C10.7213 11.7592 8.88098 13.8723 8.1172 17.3912C7.49065 16.4191 7.18019 15.4195 7.0992 14.3256C6.79099 10.157 9.36692 6.04466 13.025 4.94813C13.629 4.76734 13.773 4.48306 13.7471 3.81361C13.6999 2.6018 13.7336 1.38474 13.7336 0ZM14.7482 5.74466C12.8011 5.96737 11.1622 6.82677 9.86973 8.49056C8.60764 10.115 7.74262 13.0404 8.15657 14.3112C9.56715 11.2915 11.8664 9.95784 14.7516 9.53993V13.1413C16.6909 11.3125 18.5323 9.5753 20.413 7.80147C18.5244 6.01977 16.6841 4.28393 14.7482 2.45769V5.74466Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M9.07958 2.49602C8.75113 3.38948 8.33155 3.81919 7.48116 3.76416C5.9491 3.6646 4.40917 3.73141 2.87148 3.73665C1.67801 3.74058 1.05371 4.45064 1.05259 5.81966C1.04809 10.0984 1.04921 14.377 1.05259 18.6557C1.05371 20.0274 1.68026 20.7676 2.85799 20.7702C6.53178 20.778 10.2056 20.7793 13.8794 20.7702C15.0728 20.7676 15.6724 20.0483 15.6803 18.6662C15.6803 18.4474 15.7118 18.2221 15.6746 18.0125C15.4924 16.988 16.1201 16.5675 16.6949 16.0421C16.6949 17.2264 16.7826 18.3623 16.6735 19.4719C16.5318 20.9038 15.4643 21.9702 14.2303 21.9781C10.3316 22.0056 6.43279 22.0082 2.53515 21.9781C1.1527 21.9676 0.0278403 20.6497 0.0188414 19.037C-0.00703037 14.5172 -0.00478065 9.99879 0.0165917 5.48035C0.0244657 3.886 1.07733 2.56152 2.45416 2.51567C4.64201 2.4423 6.83212 2.49602 9.07958 2.49602Z",
  fill: "currentColor"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1988_24001"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "currentColor"
})));
function SvgAllBackendToolsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllBackendToolsIcon);
export default __webpack_public_path__ + "static/media/All Backend Tools Icon.a1abfe7e5b9466f9cb87de86c4b7e483.svg";
export { ForwardRef as ReactComponent };